import React, { memo, useMemo } from 'react'
import { Box, useTheme } from '@mui/material'

/** Skeleton for multi-strike header + per-strike metadata rows. */
const MultiStrikeMetadataSkeletonPlaceholder = () => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    const colors = useMemo(
        () => ({
            fill: isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.09)',
            muted: isDark ? 'rgba(255, 255, 255, 0.07)' : 'rgba(0, 0, 0, 0.06)',
        }),
        [isDark]
    )

    const strikeRowWidths = [
        [28, 16, 44, 18, 16, 44, 18],
        [32, 16, 40, 18, 16, 48, 18],
        [28, 16, 52, 18, 16, 40, 18],
        [36, 16, 44, 18, 16, 44, 18],
    ]

    return (
        <Box
            className="pane-meta-container"
            sx={{
                position: 'absolute',
                top: '4px',
                left: '6px',
                zIndex: 6,
                pointerEvents: 'none',
                display: 'flex',
                flexDirection: 'column',
                gap: 0.25,
                maxWidth: 'calc(100% - 12px)',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, height: 24 }}>
                <Box sx={{ width: 18, height: 18, borderRadius: '50%', bgcolor: colors.muted, flexShrink: 0 }} />
                <Box sx={{ width: 72, height: 14, borderRadius: 0.5, bgcolor: colors.fill, flexShrink: 0 }} />
                <Box sx={{ width: 48, height: 14, borderRadius: 0.5, bgcolor: colors.muted, flexShrink: 0 }} />
                <Box sx={{ width: 120, height: 12, borderRadius: 0.5, bgcolor: colors.muted, flexShrink: 0 }} />
            </Box>
            {strikeRowWidths.map((cols, rowIndex) => (
                <Box
                    key={rowIndex}
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.75, height: 24, pl: 0.25 }}
                >
                    {cols.map((width, colIndex) => (
                        <Box
                            key={colIndex}
                            sx={{
                                width,
                                height: 11,
                                borderRadius: 0.5,
                                flexShrink: 0,
                                bgcolor: colIndex === 2 || colIndex === 5 ? colors.fill : colors.muted,
                            }}
                        />
                    ))}
                </Box>
            ))}
        </Box>
    )
}

export default memo(MultiStrikeMetadataSkeletonPlaceholder)
